var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3, _react_refresh_temp_4;
_react_refresh_temp_3 = $RefreshSig$();
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable i18next/no-literal-string -- Dev tools don't use translations */
import { useCallback, useMemo } from 'react';
import { Box, Button, ComboboxField, Typography, useToastService, } from '@lucidlink/uicore';
import { FormRoot, useFormRoot } from '@lucidlink/uicore/form-builder';
import { useUserWorkspaces } from '#query-hooks';
import { useBusinessAnnualConversion, useBusinessMonthlyConversion, useEnterpriseAnnualConversion, useEnterpriseMonthlyConversion, } from './hooks';
const BillingConversionContent = () => {
    _react_refresh_temp_3();
    const { formData: { workspaceId: selectedWorkspaceId }, } = useFormRoot();
    const { query: { data: userWorkspaces = [] }, } = useUserWorkspaces();
    const { addToast } = useToastService();
    const workspaceOptions = useMemo(() => userWorkspaces.map((workspace) => ({
        id: workspace.id,
        text: workspace.name,
    })), [userWorkspaces]);
    const handleSuccess = useCallback((message) => () => {
        addToast({
            content: {
                message,
            },
            kind: 'positive',
            'data-testid': 'billing-conversion-success',
        });
    }, [addToast]);
    const handleError = useCallback((error) => {
        addToast({
            content: {
                message: `Failed to convert billing plan: ${error instanceof Error ? error.message : 'Unknown error'}`,
            },
            kind: 'negative',
            'data-testid': 'billing-conversion-error',
        });
    }, [addToast]);
    const { mutation: { isPending: isPendingConvertToBusinessMonthly, mutate: convertToBusinessMonthly, }, } = useBusinessMonthlyConversion(selectedWorkspaceId || '', {
        onSuccess: handleSuccess('Successfully converted to Business Monthly'),
        onError: handleError,
    });
    const { mutation: { isPending: isPendingConvertToBusinessAnnual, mutate: convertToBusinessAnnual, }, } = useBusinessAnnualConversion(selectedWorkspaceId || '', {
        onSuccess: handleSuccess('Successfully converted to Business Annual'),
        onError: handleError,
    });
    const { mutation: { isPending: isPendingConvertToEnterpriseMonthly, mutate: convertToEnterpriseMonthly, }, } = useEnterpriseMonthlyConversion(selectedWorkspaceId || '', {
        onSuccess: handleSuccess('Successfully converted to Enterprise Monthly'),
        onError: handleError,
    });
    const { mutation: { isPending: isPendingConvertToEnterpriseAnnual, mutate: convertToEnterpriseAnnual, }, } = useEnterpriseAnnualConversion(selectedWorkspaceId || '', {
        onSuccess: handleSuccess('Successfully converted to Enterprise Annual'),
        onError: handleError,
    });
    const isConverting = isPendingConvertToBusinessMonthly ||
        isPendingConvertToBusinessAnnual ||
        isPendingConvertToEnterpriseMonthly ||
        isPendingConvertToEnterpriseAnnual;
    return (_jsxs(Box, { gap: "m", orientation: "vertical", children: [_jsx(Typography, { color: "accent", kind: "h5", children: "Billing Plan Conversion" }), _jsx(ComboboxField, { "data-testid": "workspace-selector", disabled: isConverting, id: "workspaceId", isMultiselect: false, isSearchable: false, label: "Select workspace", name: "workspaceId", options: workspaceOptions, placeholder: "Select workspace..." }), _jsxs(Box, { align: "center", gap: "sm", children: [_jsx(Button, { "data-testid": "business-monthly-button", disabled: !selectedWorkspaceId, isLoading: isConverting, kind: "secondary", onClick: () => convertToBusinessMonthly(), children: "Business Monthly" }), _jsx(Button, { "data-testid": "business-annual-button", disabled: !selectedWorkspaceId, isLoading: isConverting, kind: "secondary", onClick: () => convertToBusinessAnnual(), children: "Business Annual" }), _jsx(Button, { "data-testid": "enterprise-monthly-button", disabled: !selectedWorkspaceId, isLoading: isConverting, kind: "secondary", onClick: () => convertToEnterpriseMonthly(), children: "Enterprise Monthly" }), _jsx(Button, { "data-testid": "enterprise-annual-button", disabled: !selectedWorkspaceId, isLoading: isConverting, kind: "secondary", onClick: () => convertToEnterpriseAnnual(), children: "Enterprise Annual" })] })] }));
};
_react_refresh_temp_1 = BillingConversionContent;
$RefreshReg$(_react_refresh_temp_1, "BillingConversionContent");
_react_refresh_temp_3(BillingConversionContent, "2drVIwm5EJCWt6IUJui3i27fHII=", false, () => [useFormRoot, useUserWorkspaces, useToastService, useBusinessMonthlyConversion, useBusinessAnnualConversion, useEnterpriseMonthlyConversion, useEnterpriseAnnualConversion]);
export const BillingConversion = () => {
    _react_refresh_temp_4();
    const { query: { data: userWorkspaces = [] }, } = useUserWorkspaces();
    const initialWorkspaceId = userWorkspaces[0]?.id ?? '';
    return (_jsx(FormRoot, { "data-testid": "billing-conversion-form", initialResetState: {
            workspaceId: initialWorkspaceId,
        }, children: _jsx(BillingConversionContent, {}) }));
};
_react_refresh_temp_2 = BillingConversion;
$RefreshReg$(_react_refresh_temp_2, "BillingConversion");
_react_refresh_temp_4(BillingConversion, "7iPUH9AQGhS6aMSdXfMjdl/MkBU=", false, () => [useUserWorkspaces]);
